/**
 * Mock Regional Payment Provider
 *
 * Placeholder for Alipay, FPS, PayMe integration.
 * Replace with a live regional gateway by:
 * 1. Creating a new provider file
 * 2. Registering it in paymentRegistry.ts
 * 3. Setting NEXT_PUBLIC_PAYMENT_PROVIDER env var
 */

import type {
  PaymentProvider,
  PaymentMethod,
  InitPaymentParams,
  InitPaymentResult,
} from "../types";

const methods: PaymentMethod[] = [
  { id: "alipay", name: "Alipay", region: "China" },
  { id: "fps", name: "FPS", region: "Hong Kong" },
  { id: "payme", name: "PayMe", region: "Hong Kong" },
];

export const mockPaymentProvider: PaymentProvider = {
  id: "mock-regional",
  supportedMethods: methods,

  supportsMethod(methodId: string): boolean {
    return methods.some((m) => m.id === methodId);
  },

  async initPayment(params: InitPaymentParams): Promise<InitPaymentResult> {
    // Simulate API call - replace with real gateway
    await new Promise((r) => setTimeout(r, 500));

    return {
      success: true,
      redirectUrl: `/payment/confirm?method=${params.methodId}&plan=${params.planId}&email=${encodeURIComponent(params.email)}`,
      qrCodeUrl: `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=atabet-pay-${params.planId}`,
    };
  },
};
